'use client';

import { useFitGuideTracking } from '../hook/useFitGuideTracking';
import Banner from './Banner';
import CutFitSection from './CutFitSection';
import Part1 from './Part1';
import Part2 from './Part2';
import Part3 from './Part3';
import Part4 from './Part4';
import Part5 from './Part5';

interface FitGuideData {
  section_banner?: any;
  section_part1?: any;
  cut_fit_section?: any;
  section_part2?: any;
  section_part3?: any;
  section_part4?: any;
  section_part5?: any;
  seoData?: any;
}

interface FitGuideClientProps {
  mobile: FitGuideData | null;
  pc: FitGuideData | null;
  isMobile: boolean;
}

export default function FitGuideClient({ mobile, pc, isMobile }: FitGuideClientProps) {
  // 初始化埋点 - 页面浏览埋点会在 hook 中自动触发
  const { trackMktClick, trackPageExposure } = useFitGuideTracking();

  // 处理下载点击埋点
  const handleDownloadClick = (btn_link?: string) => {
    trackMktClick('Frame Cutouts', 0, '4', btn_link);
  };

  // 处理曝光埋点
  const handleExposure = (
    mkt_name: string,
    pits_index: number,
    pits_jump_type: string,
    pits_jump_content: string,
  ) => {
    trackPageExposure(mkt_name, pits_index, pits_jump_type, pits_jump_content);
  };

  return (
    <div className="fit-guide min-h-screen">
      <div className="fit-guide-container">
        {/* Banner区域 */}
        <Banner mobile={mobile?.section_banner} pc={pc?.section_banner} isMobile={isMobile} />

        {/* Part1区域 */}
        <Part1 data={isMobile ? mobile?.section_part1 : pc?.section_part1} isMobile={isMobile} />

        {/* CutFitSection区域 - 包含曝光和点击埋点 */}
        <CutFitSection
          data={isMobile ? mobile?.cut_fit_section : pc?.cut_fit_section}
          isMobile={isMobile}
          onDownloadClick={handleDownloadClick}
          onExposure={handleExposure}
        />

        {/* Part2区域 */}
        <Part2 data={isMobile ? mobile?.section_part2 : pc?.section_part2} isMobile={isMobile} />

        {/* Part3区域 */}
        <Part3 data={isMobile ? mobile?.section_part3 : pc?.section_part3} isMobile={isMobile} />

        {/* Part4区域 */}
        <Part4 data={isMobile ? mobile?.section_part4 : pc?.section_part4} isMobile={isMobile} />

        {/* Part5区域 */}
        <Part5 data={isMobile ? mobile?.section_part5 : pc?.section_part5} isMobile={isMobile} />
      </div>
    </div>
  );
}
